import React from "react";
import { MdArrowDropDown, MdOutlineArrowDropUp } from "react-icons/md";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import EmptySnag from "../../../assets/empty state/EmptySnag.svg";
const ChatroomsPanel = ({
  showChatrooms,
  setShowChatrooms,
  setSnagId,
  showNewSnagForm,
  setShowNewSnagForm,
  snags = [],
  setActiveSnag,
  activeSnag,
  setTab,
  unreadCounts = {},
  lastMessages = {},
  onCreateSnag,
  newSnagTitle,
  setNewSnagTitle,
  isAdmin
}) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Chatrooms Header */}
      <div className="sticky top-0 z-10 bg-white flex items-center justify-between px-3 py-2 border-b">
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => setShowChatrooms(!showChatrooms)}
        >
          {showChatrooms ? (
            <MdOutlineArrowDropUp className="h-5 w-5 text-[#8D8D8D]" />
          ) : (
            <MdArrowDropDown className="h-5 w-5 text-[#8D8D8D]" />
          )}
          <h3 className="font-bold text-purple-900">Chat rooms</h3>
        </div>

        <button
          onClick={() => setShowNewSnagForm(!showNewSnagForm)}
          style={{ display: isAdmin ? 'flex' : 'none' }}
          className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center hover:bg-gray-300 transition"
        >
          <Plus size={16} className="text-purple-900" />
        </button>
      </div>

      {/* New Snag Form */}
      {showNewSnagForm && (
        <div className="px-4 py-1 bg-white border-b">
          <input
            type="text"
            placeholder="New chat room title..."
            className="w-full border rounded p-2 mb-2 text-sm"
            value={newSnagTitle}
            onChange={(e) => setNewSnagTitle(e.target.value)}
          />
          <div className="flex justify-end space-x-2">
            <button
              onClick={() => setShowNewSnagForm(false)}
              className="px-2 py-1 text-sm text-gray-600 hover:bg-gray-200 rounded"
            >
              Cancel
            </button>
            <button
              onClick={onCreateSnag}
              className="px-2 py-1 text-sm bg-purple-700 text-white rounded hover:bg-purple-800"
            >
              Create
            </button>
          </div>
        </div>
      )}

      {/* Snag List */}
      {showChatrooms && (
        <div className="px-1 py-1 flex flex-col gap-2">
          {snags.length === 0 ? (
            <div className="flex flex-col items-center justify-center mt-2">
              <img src={EmptySnag} alt="No Snags" className="h-44 w-44" />
              <div className="text-xs text-gray-500">No chatrooms found.</div>
            </div>
          ) : (
            snags.map((snag, index) => (
              <div
                key={snag.id}
                onClick={() => {
                  setActiveSnag?.(snag.id);
                  setSnagId?.(snag.id);
                  setTab("Chats");
                }}
                className={`p-2 px-1 border-b rounded-lg cursor-pointer ${activeSnag === snag.id ? "text-purple-900 font-semibold" : ""
                  }`}
              >
                <div className="flex items-start">
                  <div className="flex flex-col mr-2 items-center justify-center p-2 rounded-xl bg-[#CFD2E5] text-[#333B69]">
                    <span className="text-xl font-semibold">
                      {index < 9 ? "0" : ""}
                      {index + 1}
                    </span>
                  </div>
                  <div className="w-full">
                    <div className="flex items-center justify-between">
                      <div className="font-medium truncate w-70">
                        @{snag.title}
                      </div>
                      {unreadCounts[snag.id] > 0 && (
                        <div className="bg-red-500 text-white text-xs px-2 py-1 rounded-full h-5 w-5 flex items-center justify-center ml-2">
                          {unreadCounts[snag.id]}
                        </div>
                      )}
                    </div>
                    {lastMessages[snag.id] && (
                      <div className="text-xs text-gray-500 truncate mt-1">
                        {lastMessages[snag.id].senderName}:{" "}
                        {lastMessages[snag.id].text.substring(0, 30)}...
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-2 flex justify-between items-center">
                  <div></div>
                  <span className="text-xs text-gray-500">
                    {new Date(snag.createdAt).toLocaleDateString()}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </>
  );
};

export default ChatroomsPanel;
